import { Injectable } from '@angular/core';
import {
  DtxStudioIntegrationCommand,
  DtxStudioToDeviceCommand,
} from '@principle-theorem/principle-bridge-core';
import {
  IBridgeDevice,
  IPatient,
} from '@principle-theorem/principle-core/interfaces';
import { DocumentReference, WithRef } from '@principle-theorem/shared';
import { BridgeCommandsService } from '../../../bridge-commands.service';

@Injectable()
export class DtxStudioFeatureService {
  constructor(private _bridgeCommands: BridgeCommandsService) {}

  async openDtxStudio(
    patient: WithRef<IPatient>,
    type: DtxStudioToDeviceCommand,
    deviceRef: DocumentReference<IBridgeDevice>
  ): Promise<void> {
    const command: DtxStudioIntegrationCommand = {
      type,
      data: {
        patient,
      },
    };
    await this._bridgeCommands.sendCommand(command, deviceRef);
  }
}
